import { useEffect, useState } from "react"

/**
 * Soft fades along the top and bottom edges of the screen on phones and
 * tablets, so content scrolling under the status bar and the browser's
 * toolbar dissolves instead of cutting off. The top fade steps aside while
 * the sticky product bar is pinned (its solid background takes over) and
 * stays hidden over the site header at the very top; the bottom fade is
 * always on.
 */
export function HomeNewEdgeFades() {
  const [showTop, setShowTop] = useState(false)

  useEffect(() => {
    let frame = 0
    // The fades are hidden from lg up, so skip measuring there; resizing down
    // measures again.
    const desktop = window.matchMedia("(min-width: 64rem)")
    const update = () => {
      frame = 0
      if (desktop.matches) return
      const bar = document.querySelector<HTMLElement>("[data-product-bar]")
      const barTop = bar?.getBoundingClientRect().top
      const pinned = barTop !== undefined && barTop <= 0.5 && barTop > -1
      setShowTop(window.scrollY > 64 && !pinned)
    }
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update)
    }
    schedule()
    window.addEventListener("scroll", schedule, { passive: true })
    window.addEventListener("resize", schedule)
    return () => {
      window.removeEventListener("scroll", schedule)
      window.removeEventListener("resize", schedule)
      if (frame) window.cancelAnimationFrame(frame)
    }
  }, [])

  return (
    <>
      <div
        aria-hidden="true"
        className={`pointer-events-none fixed inset-x-0 top-0 z-30 h-10 bg-linear-to-b from-base to-transparent transition-opacity duration-200 lg:hidden ${
          showTop ? "opacity-100" : "opacity-0"
        }`}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-x-0 bottom-0 z-30 h-12 bg-linear-to-t from-base to-transparent lg:hidden"
      />
    </>
  )
}
